import styles from './ProfileMidPanel.module.scss';
import { AiFillPicture } from 'react-icons/ai';
import { IoVideocam } from 'react-icons/io5';
import { ImAttachment } from 'react-icons/im';
import { MdEdit } from 'react-icons/md';
import TextField from '@material-ui/core/TextField';
import { useProfileContext } from '../../pages/profile/profile-context';
import FoldableCards from '../foldable-cards/FoldableCards';
import Constants from '../../constants';
import { pdfDetails } from '../../data';
import { useAppContext } from '../../app-context';

const ProfileMidPanel = () => {
  const { profileData } = useAppContext();
  const pdfData = pdfDetails;
  const dataA = [1, 2, 3, 4];
  return (
    <>
      <main className={styles.post}>
        <article className={styles.writeText}>
          <TextField
            className={styles.input}
            id='outlined-multiline-static'
            placeholder="What's on your mind ?"
            multiline
            rows={5}
          />
        </article>
        <article className={styles.buttons}>
          <section className={styles.icons}>
            <AiFillPicture className={styles.picture} />
            <IoVideocam className={styles.video} />
            <ImAttachment className={styles.attachment} />
          </section>
          <button className={`greenButton ${styles.postButton}`}>Post</button>
        </article>
      </main>
      <main className={styles.about}>
        <h3>About</h3>
        <MdEdit className={styles.edit} />
        <section className={styles.aboutText}>
          <p>{profileData.about}</p>
        </section>
      </main>
      <main className={styles.universities}>
        <FoldableCards payload={dataA} type={Constants.ADMITTED_UNIVERSITIES} />
      </main>
      <main className={styles.statementOfPurpose}>
        <FoldableCards
          payload={pdfData}
          type={Constants.STATEMENT_OF_PURPOSE}
        />
      </main>
      <main className={styles.letterOfRecommendation}>
        <FoldableCards
          payload={pdfData}
          type={Constants.LETTER_OF_RECOMMENDATIONS}
        />
      </main>
    </>
  );
};

export default ProfileMidPanel;
